import React, { useState } from 'react'
import { Accordion, Card, Button } from 'react-bootstrap'

const Index = () => {

    const [activeTab, setActiveTab] = useState("0")

    return(
        <div className="tab-section-container">
            <div className="inner-tab-section-container">
                <p className="introduction-text">
                    Gjennom vår WYSIWYG-editor (what you see is what you get) kan du utforme profesjonelle og tilpassede e-postmaler som du kan bruke i utsendingene dine. Du kan velge alt fra fonter, farger og størrelser til ulik tekstformattering og bilder. Alle malene vil bli generert i HTML slik at majoriteten av e-postklienter vil være i stand til å lese e-posten. 
                    <br/><br/>
                    Du kan også benytte deg av koder når du skriver en mal, som kort og enkelt vil erstatte koden med den faktiske dataen dersom den er tilstede hos en kontakt den sendes ut til. For eksempel så vil {`{{kontakt_fornavn}}`} bli erstattet med fornavnet til kontakten, og {`{{kontakt_bedriftsnavn}}`} bli erstattet med selskapet kontakten jobber for.
                </p>
                <div className="accordion-container">
                <Accordion className="company-accordion" defaultActiveKey="0" activeKey={activeTab}>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="0" onClick={() => setActiveTab("0")}>
							<button className={`collapse-button ${activeTab === "0" ? "active":""}`}>{activeTab === "0" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Opprett en mal
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="0">
						<Card.Body className="card-body">
                            <p className="description-text">For å kunne sende ut e-post er du avhengig av å ha opprettet minst èn mal, og slik går du frem for å opprette en:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Maler"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk på <span className="bold">"Ny mal"</span>-knappen øverst i høyre hjørne.</li>
								<li>Skriv inn og formatter innholdet slik du vil at e-posten skal se ut.</li>
								<li>Fyll inn ønsket navn på malen i tekstfeltet på høyre side.</li>
								<li>Trykk til slutt på <span className="bold">"Opprett mal"</span>-knappen.</li>
							</ol>
							<p className="description-text">Du kan finne en detaljert beskrivelse på hvordan du kan bruke koder i malen din i feltet nedenfor.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card top">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="1" onClick={() => setActiveTab("1")}>
                            <button className={`collapse-button ${activeTab === "1" ? "active":""}`}>{activeTab === "1" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Vis eksisterende mal
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="1">
						<Card.Body className="card-body">
                            <p className="description-text">Dersom du ønsker å se på en eksisterende mal gjør du slik:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Maler"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk så på malen du ønsker å se på i listen over malene dine.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
					<Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="2" onClick={() => setActiveTab("2")}>
                            <button className={`collapse-button ${activeTab === "2" ? "active":""}`}>{activeTab === "2" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Endre malen
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="2">
						<Card.Body className="card-body">
                            <p className="description-text">Hvis du vil endre på en eksisterende mal gjør du det på denne måten:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Maler"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk på penn-ikonet i samme rad som navnet på malen du ønsker å endre.</li>
								<li>Gjør deretter de nødvendige endringene du ønsker.</li>
								<li>Trykk deretter på <span className="bold">"Oppdater"</span>-knappen på høyre del av siden.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card">
				    <Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="3" onClick={() => setActiveTab("3")}>
                            <button className={`collapse-button ${activeTab === "3" ? "active":""}`}>{activeTab === "3" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Bruk av koder i mal
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="3">
						<Card.Body className="card-body">
                            <p className="description-text">
								Når du skriver en mal kan du benytte deg av koder, disse blir automatisk byttet ut med verdien den respektive koden er ment for å erstatte. Dette skjer i selve prosessen ved utsendelse av e-post, og er et nyttig verktøy å bruke for å gjøre e-postene du sender mer personlige. Eksempel på en kode kan være <span className="bold">{`{{kontakt_fornavn}}`}</span> og <span className="bold">{`{{kontakt_etternavn}}`}</span>.
								<br/><br/>
								Du kan se alle de ulike kodene du kan benytte deg av på høyre del av siden hvor du oppretter en mal, og hvilke type informasjon de erstatter. Dersom informasjonen ikke finnes på en kontakt i en kontaktliste du prøver å sende ut til, vil det ikke vises noen ting der hvor det er ment at verdien skal stå.
							</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
                <Card className="single-card">
				    <Card.Header className="card-header">
						<Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="4" onClick={() => setActiveTab("4")}>
                            <button className={`collapse-button ${activeTab === "4" ? "active":""}`}>{activeTab === "4" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Formattering av mal
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="4">
						<Card.Body className="card-body">
                            <p className="description-text">Gjennom tekstbehandleren hvor du skriver malen din får du tilgang på mange ulike verktøy for å tilpasse utseende. Du kan endre på visningen av malen din ved å bruke valgene over tekstfeltet, som gir deg mulighet til å endre på alt fra skrifttype, skriftstørrelse, tykkelse på skrift, plassering og mer.</p>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
				<Card className="single-card last">
					<Card.Header className="card-header">
					    <Accordion.Toggle className="card-toggle" as={Button} variant="link" eventKey="5" onClick={() => setActiveTab("5")}>
                            <button className={`collapse-button ${activeTab === "5" ? "active":""}`}>{activeTab === "5" ? <i class="fas fa-minus"></i>:<i class="fad fa-plus"></i>}</button>Slett mal
						</Accordion.Toggle>
					</Card.Header>
					<Accordion.Collapse eventKey="5">
						<Card.Body className="card-body">
                            <p className="description-text">Hvis du ønsker å slette en mal, gjør følgende:</p>
							<ol className="description-list">
								<li>Gå til <span className="bold">"Maler"</span> under <span className="bold">"Utsendelser"</span> fra menyen til venstre.</li>
								<li>Trykk på søppeldunk-ikonet til høyre for navnet på malen du ønsker å slette.</li>
								<li>Til slutt bekreft sletting ved å trykke på <span className="bold">"Ja, slett malen"</span>-knappen.</li>
							</ol>
						</Card.Body>
					</Accordion.Collapse>
				</Card>
			</Accordion>
                </div>
            </div>
        </div>
    )
}

export default Index